import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchLeads(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('leads')
    .select('id, name, company, email, phone, status, updated_at')
    .or(`name.ilike.${pattern},company.ilike.${pattern},email.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Leads search error:', error);
    return [];
  }

  return (data || [])
    .filter(l => matchFn(term, l.name, l.company, l.email, l.phone))
    .slice(0, limit)
    .map(l => {
      const title = l.name || l.company || 'Unbenannt';
      const subtitle = l.email || l.phone || undefined;
      
      return {
        id: l.id,
        type: 'leads' as SearchSectionId,
        title,
        subtitle,
        badge: l.status || 'Lead',
        data: l,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, l.updated_at)
      };
    });
}
